<template>
  <div class="page-project-intro">
    <div class="page-project-intro__wrap">
      <!-- Cover -->
      <div class="page-project-intro__cover" v-if="showCover">
        <!-- Cover image -->
        <WidgetPicture
          v-if="props.cover && !props.preview"
          class="is-cover"
          :image="{ custom: props.cover.responsiveImage }"
          :lazyLoad="true"
          :alt="props.alt"
        />
        <!-- Video preview -->
        <WidgetVideo
          v-if="props.preview"
          class="is-cover"
          :videoUrl="props.preview"
          :controls="false"
          :loop="true"
          :autoplay="true"
          :muted="true"
        />
      </div>
      <!-- Video -->
      <div class="page-project-intro__video">
        <WidgetVideo
          class="is-cover"
          ref="video"
          :videoUrl="props.url"
          :controls="true"
          :loop="false"
          :autoplay="false"
        />
      </div>
    </div>

    <!-- Cta -->
    <div
      class="page-project-intro__trigger"
      :class="{ '--to-hide': play && !showCover }"
    >
      <div class="page-project-intro__trigger__wrap">
        <WidgetButtonCtaIco
          :label="$t('cta.playVideo')"
          v-if="showCover && props.url"
          @click="playVideo"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesProjectIntro',
}
</script>

<script setup>
const props = defineProps({
  url: String,
  preview: String,
  cover: Object,
  alt: String,
})

const video = ref(null)
const play = ref(false)
const showCover = ref(true)

watch(
  () => play.value,
  (play) => {
    if (play) {
      video.value.videoElement?.play()
      showCover.value = false
    } else {
      videoElement.value?.pause()
    }
  }
)

const playVideo = () => {
  play.value = true
}
</script>

<style lang="scss">
@import './style.scss';
</style>
